import { BlockHeading } from 'components/Content/Atoms/BlockHeading';
import { ContentType } from 'types/publishedAssets';
import { ContentContainer } from 'components/Content/Atoms/ContentContainer';
import { useGetContentTranslations } from 'utils/useGetContentTranslations';
import { Icon } from 'components/Atoms/Icon/Icon';
import { ActionButton, ButtonType } from 'components/Atoms/ActionButton/ActionButton';
import { useContext, useState } from 'react';
import { PageContext } from 'src/context/PageContext';
import { useTranslation } from 'react-i18next';
import { getInitialVisibleCount } from 'src/utils/getInitialVisibleCount';
import styles from './Document.module.scss';

interface Props {
  content: ContentType;
}

export function Document(props: Props) {
  const { content } = props;
  const { page, urlParams } = useContext(PageContext);
  const { t } = useTranslation();
  const { translate } = useGetContentTranslations();
  const currentLocaleCode = urlParams?.locale as string;
  const defaultLocaleCode = page?.default_locale_code as string;
  const title = translate(content.translations, 'label');
  const description = translate(content.translations, 'description');
  const documentCount = content.components.length;
  const showByDefault = getInitialVisibleCount(content.metadata, 3);
  const [showAllDocuments, setShowAllDocuments] = useState(false);
  return (
    <ContentContainer content={content}>
      <div className={styles.documentContainer}>
        <BlockHeading title={title} secondaryText={description} id={content.id} />
        <div className={styles.documentsList}>
          {content.components.map((component, index) => {
            if (showByDefault && !showAllDocuments && index > showByDefault - 1) return null;
            const documentTitle =
              component.media_item?.[currentLocaleCode]?.alt_text ||
              component.media_item?.[defaultLocaleCode]?.alt_text ||
              (component.media_item?.metadata as Record<string, string>)?.file_name;
            const documentDescription = translate(component.translations, 'description');
            const documentUrl =
              component.media_item?.[currentLocaleCode]?.url || component.media_item?.[defaultLocaleCode]?.url;
            return (
              <a
                key={component.id}
                href={documentUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.documentItem}
              >
                <div className={styles.documentTextContainer}>
                  {documentTitle && <h3 className={styles.documentTitle}>{documentTitle}</h3>}
                  {documentDescription && <p className={styles.documentDescription}>{documentDescription}</p>}
                </div>
                <Icon name="download-arrow" classname={styles.downloadIcon} />
              </a>
            );
          })}
        </div>
        {showByDefault > 0 && documentCount > showByDefault && (
          <ActionButton
            className={styles.showAlldocumentsButton}
            type={ButtonType.ACTION_SECONDARY}
            onClick={() => setShowAllDocuments(!showAllDocuments)}
          >
            {showAllDocuments ? t('document.showLess') : t('document.showAllDocuments')}
            <Icon name={showAllDocuments ? 'chevron-up' : 'chevron-down'} />
          </ActionButton>
        )}
      </div>
    </ContentContainer>
  );
}

export default Document;
